import { Bug, Hash, Radio, Tag } from 'lucide-react';
import { InfoPanel } from '@/components/shared/InfoPanel';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { WorkflowResourceLink } from '@/components/shared/WorkflowResourceLink';
import { CopyIdChip } from '@/components/shared/CopyIdChip';
import { DetailField, DetailList } from '@reflex/ui/components/shared/DetailList';
import { ViewLogsButton } from './ViewLogsSheet';
import { useSandboxBridgeVersion } from '@/hooks/agents/useSandboxBridgeVersion';
import type { Agent } from '@/lib/types';

export function AgentDetailInfraSection({ agent }: { agent: Agent }) {
  const bridgeVersion = useSandboxBridgeVersion(agent.id);
  return (
    <section data-testid="agent-detail-infra">
      <IconSectionHeader
        icon={Bug}
        className="mb-2 gap-1.5"
        labelAs="h3"
        labelClassName="font-semibold"
      >
        Debug
      </IconSectionHeader>
      <InfoPanel>
        <DetailList>
          {agent.devboxId ? (
            <DetailField icon={Hash} label="Devbox">
              <CopyIdChip id={agent.devboxId} icon={Hash} label="Devbox" />
            </DetailField>
          ) : (
            <DetailField icon={Hash} label="Devbox">
              <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
                <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                Not yet provisioned
              </span>
            </DetailField>
          )}
          <DetailField icon={Hash} label="Agent">
            <CopyIdChip id={agent.id} icon={Hash} label="Agent" />
          </DetailField>
          <DetailField icon={Radio} label="Stream">
            <WorkflowResourceLink type="axon" id={agent.streamId} />
          </DetailField>
          {agent.devboxId && (
            <DetailField icon={Tag} label="Bridge">
              {bridgeVersion ? (
                <span
                  className="font-mono text-xs text-foreground"
                  data-testid="agent-detail-bridge-version"
                >
                  v{bridgeVersion}
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
                  <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground" />
                  Not connected
                </span>
              )}
            </DetailField>
          )}
        </DetailList>
        {agent.devboxId && (
          <div className="flex flex-wrap items-center gap-1.5 pt-3 pl-7">
            <ViewLogsButton agentId={agent.id} />
          </div>
        )}
      </InfoPanel>
    </section>
  );
}
